<template>
  <div class="material-list">
    <div class="search" v-if="!isLimit">
      <span class="goBack" @click="goBack"> <van-icon name="arrow-left" />返回 </span>
      <van-search v-model="filter.name" show-action shape="round" class="flex1" clearable @search="search" @clear="search" placeholder="请输入搜索关键词">
        <template #action>
          <div @click="search" :style="{ color: filter.name ? '#277fff' : '' }">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="screening-condition" v-if="!isLimit">
      <div class="condition">
        <van-tag v-for="item in checkedList.slice(0, 4)" :key="item.id" color="#E3EFFF" size="large" text-color="#277fff">{{ item.name }}</van-tag>
      </div>
      <van-dropdown-menu active-color="#3d3d3d" :close-on-click-outside="false">
        <van-icon name="filter-o" class="filter-icon" />
        <van-dropdown-item title="筛选" ref="item" class="arrow-sear">
          <div style="flex: 1; overflow-y: scroll; padding-bottom: 40px">
            <div class="type-list">
              <p>素材类型</p>
              <ul>
                <li v-for="(item, index) in typeList" :class="{ activeType: typeIndex === index }" :key="item.id" @click="handleIndex(1, item, index)">
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="file-list">
              <p>文件类型</p>
              <ul>
                <li v-for="(item, index) in fileList" :class="{ activeFile: fileIndex === index }" :key="item.id" @click="handleIndex(2, item, index)">
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <van-collapse v-model="activeNames">
              <van-collapse-item v-for="(item, index) in labelList" :key="item.groupId" :title="item.groupName" :name="item.groupId">
                <ul>
                  <!-- :class="{labelIndex: 'labelIndex_'+index === index2}"
                  :class="[index === 0 ? (labelIndex_0 === index2 ? 'labelIndex' : '') : 
                    (index === 1 ? (labelIndex_1 === index2 ? 'labelIndex' : '') : '')
                    ]"
                 -->
                  <li
                    v-for="(item2, index2) in item.labels"
                    :key="item2.labelId"
                    :class="[
                      index === 0
                        ? labelIndex_0 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 1
                        ? labelIndex_1 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 2
                        ? labelIndex_2 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 3
                        ? labelIndex_3 === index2
                          ? 'labelIndex'
                          : ''
                        : index === 4
                        ? labelIndex_4 === index2
                          ? 'labelIndex'
                          : ''
                        : '',
                    ]"
                    @click="handleLabelIndex(item, index, item2, index2)"
                  >
                    {{ item2.labelName }}
                  </li>
                </ul>
              </van-collapse-item>
            </van-collapse>
            <div class="date">
              <p>时间</p>
              <div class="start-date">
                <van-cell :title="filter.startTime" @click="showPopup(1)">
                  <template #right-icon>
                    <van-icon name="calendar-o" class="calendar-o" />
                  </template>
                </van-cell>
              </div>
              <div class="line"></div>
              <div class="end-date">
                <van-cell :title="filter.endTime" @click="showPopup(2)">
                  <template #right-icon>
                    <van-icon name="calendar-o" class="calendar-o" />
                  </template>
                </van-cell>
              </div>
            </div>
          </div>
          <div class="cancelSub">
            <van-button class="reset" type="default" @click="onCancel"> 重置 </van-button>
            <van-button type="info" block @click="onConfirm"> 确认 </van-button>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>

    <div class="tree-content" v-if="!isLimit && childlist.length > 0">
      <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedtext" @load="onLoad">
          <van-collapse v-model="activeName" accordion @change="changeFn">
            <van-collapse-item v-for="(item, index) in childlist" :key="item.id" :title="item.name" :name="index" :is-link="false">
              <template #icon>
                <van-icon v-if="activeName === index" class="reply-down" :name="replyDownImg" />
                <van-icon v-else class="reply-open" :name="replyOpenImg" />
              </template>
              <div v-if="item.materialFileList.length > 0" class="material-file-list">
                <div v-for="item2 in item.materialFileList" :key="item2.id" class="material-file-item" @click="shareList(item2)">
                  <div v-if="item2.type != '1'" class="content">
                    <div class="img" :class="{ videoImg: item2.type == 5 }">
                      <img v-if="item2.type == 2" :src="item2.url" alt="" />
                      <img class="video-img" v-if="item2.type == 5" :src="item2.fileCover" alt="" />
                      <img v-if="item2.type == 6 && item2.url.split('.').pop() === 'pdf'" :src="pdfImg" alt="" />
                      <img v-if="item2.type == 6 && item2.url.split('.').pop() !== 'pdf'" :src="textImg" alt="" />
                      <img v-if="item2.type == 3" :src="item2.fileCover || websiteImg" alt="" />
                    </div>
                    <!-- <div class="img" v-else>
                      <img :src="item2.fileCover" alt="" />
                    </div> -->
                    <div class="content-name" :class="{ videoContent: item2.type == 5 }">
                      <p>【{{ fileList.find((v) => v.id == item2.type).name }}】{{ item2.fileName }}</p>
                      <div class="content-timeBtn">
                        <span class="createTime">{{ item2.createTime }}</span>
                        <span v-if="item2.type != 6 || (item2.type == 6 && item2.url.split('.').pop() === 'pdf')" class="preview" @click.stop="preview($event, item2)">预览</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="content-text">
                    <p class="pack-up" v-if="!isZhankai">【文本】{{ item2.content }}</p>
                    <p class="unfold" v-else>【文本】{{ item2.content }}</p>
                    <span class="pack" v-if="!isZhankai && item2.content.length > 110" @click.stop="packUp($event, item2)">展开</span>
                    <span class="pack" v-if="isZhankai && item2.content.length > 110" @click.stop="packUp($event, item2)">收起</span>
                  </div>
                  <p class="createTime1" v-if="item2.type == '1'">
                    {{ item2.createTime }}
                  </p>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="noLimit" v-if="isLimit">
      <img :src="noLimitImg" alt="" />
      <p>抱歉，你无法访问改页面</p>
    </div>
    <div class="noData" v-if="!isLimit && childlist.length === 0">
      <img :src="noDataImg" alt="" />
      <p>未匹配到结果</p>
      <p>请尝试改变查询条件</p>
    </div>
    <!-- 日期选择 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="confirmDate"
        @cancel="show = false"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
    <!-- 预览pdf -->
    <van-popup v-model="showPdf" position="bottom" closeable round class="popup-pdf" @closed="closePopup">
      <div class="detail-popup">
        <div id="pdf-detail"></div>
      </div>
    </van-popup>
    <!-- 预览图片 -->
    <!-- <van-image-preview v-model="showImg" :showIndex="false" :images="[imgUrl]"> 
    </van-image-preview> -->
    <van-dialog v-model="showImg" :showConfirmButton="false" :closeOnClickOverlay="true" width="90%" :class="{ videoDialog: showType == '5' }" @close="closeImg">
      <img v-if="showType == '2'" :src="imgUrl" />
      <!-- :poster="`${videoUrl}?vframe/jpg/offset/1/w/100%/h/580`" -->
      <video v-if="showType == '5'" :autoplay="false" :src="videoUrl" controls />
      <div class="btn">
        <span @click="shareImgVideo">
          <van-icon name="share" />
          分享</span
        >
        <span @click="closeImg">关闭</span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Toast } from "vant";
import treeChild from "@/components/treeChild.vue";
import "@/utils/rem";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import { materialTypeList, materialFileList, getMaterialList, materialLabelList, queryMaterialMediaId, weRadarEncrypt } from "@/server/api.js";
import { wefunstatistics, addressBar, formatDate } from "@/utils/public";
import { wxConfig } from "@/views/fastReply/js/config";
export default {
  components: { treeChild },
  data() {
    return {
      loading: false,
      finished: false,
      isLimit: false,
      childlist: [],
      finishedtext: "没有更多了",
      show: false, // 日期弹窗
      refreshing: false,
      filter: {
        name: "",
        materialGroupId: this.$route.query.id, // 素材库id
        materialTypeId: "", // 类型id
        type: "", // 文件id
        labelList: [],
        startTime: "请选择",
        endTime: "请选择",
        pageNum: 1,
        pageSize: 9999,
      },
      noLimitImg: require("../../assets/images/noLimit.png"),
      noDataImg: require("../../assets/images/no_data.png"),
      replyOpenImg: require("../../assets/images/replyopen.png"),
      replyDownImg: require("../../assets/images/replydown.png"),
      imgImg: require("../../assets/images/img.png"),
      pdfImg: require("../../assets/images/pdf.png"),
      textImg: require("../../assets/images/text.png"),
      videoImg: require("../../assets/images/video.png"),
      websiteImg: require("../../assets/images/website.png"),
      typeIndex: 0,
      fileIndex: 0,
      labelIndex_0: 0,
      labelIndex_1: 0,
      labelIndex_2: 0,
      labelIndex_3: 0,
      labelIndex_4: 0,
      currentDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 11, 31),
      dateType: "",
      checkedList: [],
      typeList: [],
      fileList: [],
      activeName: "",
      isZhankai: false,
      showPdf: false,
      showImg: false,
      showVideo: false,
      imgUrl: "",
      shareImgVideoObj: "",
      videoUrl: "",
      showType: "",
      pdfh5: null,
      windowUrl: window.location.href.split("#")[0],
      jsList: ["getCurExternalContact", "sendChatMessage"],
      userId: "",
      wechatUserId: "",
      activeNames: [],
      labelList: [],
      tempSecondLabels: [], // 所有二级标签组成的数组
      checkedLabels: [], // 选中的二级标签的集合
    };
  },
  // created() {
  //   this.getTypeList();
  //   this.getFileList();
  //   this.getLabelList();
  //   this.getList();
  // },
  async mounted() {
    if (localStorage.getItem("token")) {
      wxConfig(this.windowUrl, this.jsList).then(() => {
        if (localStorage.getItem("materialobj")) {
          let materialobj = JSON.parse(localStorage.getItem("materialobj"));
          this.typeList = materialobj.typeList;
          this.fileList = materialobj.fileList;
          this.labelList = materialobj.labelsList;

          this.filter.name = materialobj.name;
          this.filter.startTime = materialobj.startTime;
          this.filter.endTime = materialobj.endTime;
          this.filter.labelList = materialobj.labelList;
          this.filter.materialTypeId = materialobj.materialTypeId;
          this.filter.type = materialobj.type;
          this.checkedList = materialobj.checkedList;
          this.fileIndex = materialobj.fileIndex;
          this.typeIndex = materialobj.typeIndex;
          this.labelIndex_0 = materialobj.labelIndex_0;
          this.labelIndex_1 = materialobj.labelIndex_1;
          this.labelIndex_2 = materialobj.labelIndex_2;
          this.labelIndex_3 = materialobj.labelIndex_3;
          this.labelIndex_4 = materialobj.labelIndex_4;
          this.activeNames = materialobj.activeNames;
          this.getList();
        } else {
          this.getWechatId();
          this.getTypeList();
          this.getFileList();
          this.getLabelList();
          this.getList();
        }
      });
    } else {
      addressBar("token", this.windowUrl);
    }
  },
  destroyed() {
    localStorage.removeItem("materialobj");
  },
  methods: {
    getWechatId() {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.userId) {
          that.wechatUserId = res.userId;
        }
      });
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.childlist = [];
      this.finished = false;
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      // 重新加载数据

      if (this.refreshing) {
        this.refreshing = false;
      }
      this.getList();
    },
    onLoad() {
      if (this.refreshing) {
        this.refreshing = false;
      }
      this.pageNum++;
      this.getList();
    },
    // 筛选--重置
    onCancel() {
      this.filter.startTime = "请选择";
      this.filter.endTime = "请选择";
      this.filter.materialGroupId = this.$route.query.id;
      this.filter.type = "";
      this.filter.labelList = [];

      this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
      this.checkedList = [];
      this.checkedLabels = [];
      this.typeIndex = 0;
      this.fileIndex = 0;
      this.labelIndex_0 = 0;
      this.labelIndex_1 = 0;
      this.labelIndex_2 = 0;
      this.labelIndex_3 = 0;
      this.labelIndex_4 = 0;
      this.activeNames = [];
      this.getList();
      this.$refs.item.toggle();
    },
    // 筛选--确认
    onConfirm() {
      this.checkedList = [];
      this.filter.labelList = [];
      if (this.filter.materialTypeId) {
        this.checkedList.push(this.typeList.find((k) => k.id === this.filter.materialTypeId));
      }
      if (this.filter.type) {
        this.checkedList.push(this.fileList.find((v) => v.id === this.filter.type));
      }
      let tempArr = this.checkedLabels
        .filter((m) => m.labelId)
        .map((lab) => {
          this.filter.labelList.push(lab.labelId);
          return {
            id: lab.labelId,
            name: lab.labelName,
          };
        });
      this.checkedList.push(...tempArr);
      this.activeNames = [];
      this.getList();
      this.$refs.item.toggle();
    },
    // 类型
    async getTypeList() {
      const res = await materialTypeList();
      // this.typeList = res.data.filter((k) => k.id);
      // this.typeList.unshift({ id: "", name: "全部" });
    },
    // 文件
    async getFileList() {
      const res = await materialFileList();
      // this.fileList = res.data.filter((k) => k.id !== "" && +k.id !== 4);
      // this.fileList.unshift({ id: "", name: "全部" });
    },
    // 标签组
    async getLabelList() {
      const res = await materialLabelList();
      // this.labelList = res.data.map((item, index) => {
      //   item.labels.unshift({ labelId: "", labelName: "全部" });
      //   item.labels.forEach((k) => {
      //     k.groupId = item.groupId;
      //   });
      //   return item;
      // });
    },
    // 切换筛选类型
    handleIndex(type, item, index) {
      if (type === 1) {
        this.typeIndex = index;
        this.filter.materialTypeId = item.id;
      } else if (type === 2) {
        this.fileIndex = index;
        this.filter.type = item.id;
      }
    },
    handleLabelIndex(item, index, item2, index2) {
      console.log(index, item2);
      this["labelIndex_" + index] = index2;
      this.checkedLabels = [...this.checkedLabels.filter((k) => k.groupId !== item2.groupId), item2];
    },
    // 日期弹窗
    showPopup(type) {
      this.dateType = type;
      if (type === 1) {
        let dateList = this.filter.startTime.split("-");
        this.currentDate =
          this.filter.startTime !== "请选择"
            ? new Date(dateList[0], dateList[1] - 1, dateList[2])
            : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

        if (this.filter.endTime !== "请选择") {
          let tempEnd = this.filter.endTime.split("-");
          this.minDate = new Date(2010, 0, 1);
          this.maxDate = new Date(tempEnd[0], tempEnd[1] - 1, tempEnd[2]);
        }
      } else {
        let endTimeList = this.filter.endTime.split("-");
        this.currentDate =
          this.filter.endTime !== "请选择"
            ? new Date(endTimeList[0], endTimeList[1] - 1, endTimeList[2])
            : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        if (this.filter.startTime !== "请选择") {
          let tempStart = this.filter.startTime.split("-");
          this.minDate = new Date(tempStart[0], tempStart[1] - 1, tempStart[2]);
          this.maxDate = new Date(2030, 11, 31);
        }
      }
      this.show = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    },
    // 选择日期
    confirmDate(val) {
      if (this.dateType === 1) {
        this.filter.startTime = formatDate(new Date(val).getTime());
      } else {
        this.filter.endTime = formatDate(new Date(val).getTime());
      }
      this.show = false;
    },
    // 获取数据
    async getList() {
      this.loading = true;
      this.childlist = [];
      this.activeName = "";
      let params = { ...this.filter };
      if (params.startTime === "请选择") {
        params.startTime = "";
      }
      if (params.endTime === "请选择") {
        params.endTime = "";
      }
      const res = await getMaterialList(params);
      if (res.code === "306") {
        this.isLimit = true;
        this.finishedtext = res.msg;
        this.finished = true;
        return;
      }
      if (res.code !== "200") {
        Toast.fail(res.msg);
        this.loading = false;
        this.finishedtext = res.msg;
        this.finished = true;
        return;
      } else {
        this.childlist = this.childlist.concat(res.data.list);
        this.childlist.forEach((k) => {
          if (k.materialFileList.length > 0) {
            k.materialFileList.forEach((v) => {
              if (v.type == 5) {
                v.fileCover = v.url + "?vframe/jpg/offset/1/w/160/h/134";
              }
            });
          }
        });
        this.isLimit = false;
        if (res.data.total == 0 || res.data.total < this.filter.pageSize) {
          this.finishedtext = this.childlist.length ? "没有更多了" : "暂无话术";
          //数据全部加载完成
          this.finished = true;
          this.loading = false;
          // if (scroll) {
          //   this.$nextTick(() => {
          //     window.scrollTo(0, scroll);
          //   });
          // }
        } else {
          this.finished = false;
        }
      }
    },
    // 折叠
    changeFn(val) {
      // console.log(val);
      this.isZhankai = false;
    },
    // 分享发送
    async shareList(obj) {
      let siteImg = "http://qfzy.static.1000phone.net/img/2023-06-05/3W12xTBHw8uz5P2a/site.png";

      let mediaId = "";
      if (obj.type == "2" || obj.type == "5" || obj.type == "6") {
        const res = await queryMaterialMediaId({
          id: obj.id,
          type: obj.type,
          url: obj.url,
        });
        mediaId = { mediaid: res.data };
      }
      let msgTypeObjArr = [
        { msgtype: "text", enterChat: false, text: { content: obj.content } },
        { msgtype: "image", enterChat: false, image: mediaId },
        {
          msgtype: "news",
          enterChat: false,
          news: {
            link: obj.url,
            title: obj.fileName,
            desc: "",
            imgUrl: obj.fileCover || siteImg,
          },
        },
        {},
        { msgtype: "video", enterChat: false, video: mediaId },
        { msgtype: "file", enterChat: false, file: mediaId },
      ];
      wx.invoke("sendChatMessage", msgTypeObjArr[obj.type - 1], function (res) {
        if (res.err_msg == "sendChatMessage:ok") {
          //发送成功
          Toast.success("发送成功");
        } else {
          // Toast.fail(res.err_msg);
        }
      });
    },
    // 展开或收起
    packUp(e, row) {
      e.stopPropagation();
      this.isZhankai = !this.isZhankai;
    },
    // 预览
    preview(e, row) {
      e.stopPropagation();
      // this.imgUrl = [];
      if (row.type == "6") {
        // pdf
        this.showPdf = true;
        this.$nextTick(() => {
          this.pdfh5 = new Pdfh5("#pdf-detail", {
            pdfurl: row.url,
            maxZoom: 3,
            lazy: true,
            scrollEnable: true,
            clientheight: 0,
          });
        });
      } else if (row.type == "3") {
        // 网页
        window.open(row.url);
      } else if (row.type == "2" || row.type == "5") {
        // 图片或视频
        this.showType = row.type;
        this.shareImgVideoObj = row;
        if (row.type == "2") {
          this.imgUrl = row.url;
          // this.showImg = true;
        } else if (row.type == "5") {
          this.videoUrl = row.url + "#t=0.1";
          // this.showVideo = true;
        }
        this.showImg = true;
      }
    },
    // 关闭pdf
    closePopup() {
      this.showPdf = false;
      this.showImg = false;
      this.showVideo = false;
      this.pdfh5 = null;
      this.imgUrl = "";
    },
    shareImgVideo() {
      this.shareList(this.shareImgVideoObj);
    },
    // 关闭图片/视频的预览
    closeImg() {
      // window.scrollTo(0, 0);
      this.shareImgVideoObj = "";
      this.videoUrl = "";
      this.imgUrl = "";
      this.showImg = false;
      this.showVideo = false;
    },
    // 搜索
    search(scroll) {
      this.childlist = [];
      this.filter.pageNum = 1;
      // this.grouplist(scroll);
      this.getList();
      // this.$refs.personalTree.activeItem();
      // this.$refs.child.activeItem();
    },
    replyConfig() {
      wxConfig(window.location.href.split("#")[0], ["sendChatMessage", "getCurExternalContact"]);
    },
    // 返回上一页
    goBack() {
      this.$router.push({ path: "/reply" });
      localStorage.setItem("replytab", "material");
    },
  },
};
</script>
<style scoped lang="less">
.material-list {
  .search {
    width: 100%;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding-top: 10px;
    .goBack {
      padding-left: 12px;
      display: inline-block;
      font-size: 28px;
      color: #277fff;
      cursor: pointer;
      margin-right: 40px;
    }
    .van-search {
      padding-bottom: 10px;
      width: 85%;
    }
    .van-search__action {
      font-size: 30px;
    }
  }
  .van-search {
    padding: 0;
    /deep/.van-icon-search {
      font-size: 28px;
    }
    /deep/.van-field__control {
      font-size: 28px;
    }
  }
  .van-search__content {
    height: 80px;
    padding-left: 30px;
    border-radius: 40px;
    background-color: #f3f3f3;
  }
  .van-search .van-cell {
    align-items: center;
  }
  .van-field__left-icon {
    height: 80px;
  }
  .screening-condition {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #fff;
    padding-bottom: 10px;
    border-bottom: 1px solid #eeeeee;
    .condition {
      background-color: #fff;
      width: 84%;
      height: 100%;
      padding-left: 28px;
      line-height: 67px;
      /deep/.van-tag {
        padding: 16px 24px;
        width: 120px;
        text-align: center;
        display: inline-block;
        margin-right: 20px;
        font-size: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: 4px;
      }
    }
    .filter-icon {
      position: absolute;
      top: 8px;
      right: 70px;
      z-index: 20;
      font-size: 30px;
    }
    .arrow-sear {
      /deep/.van-cell__title {
        font-size: 26px;
      }
    }
    /deep/ .van-dropdown-menu {
      width: 17vw;
      position: relative;
      .van-dropdown-item--down {
        margin-top: 20px;
        // top: ;
      }
      .van-dropdown-menu__bar {
        height: 50px;
        box-shadow: none;
        .van-ellipsis {
          // height: 30px;
          padding-top: 4px;
        }
      }
      .van-dropdown-menu__item {
        justify-content: flex-end;
      }
      .van-dropdown-item__content {
        border-radius: 0 0 16px 16px;
        display: flex;
        flex-direction: column;
      }
      .van-dropdown-menu__title {
        font-size: 28px;
      }
      .van-dropdown-menu__title::after {
        display: none;
      }
      .type-list,
      .file-list {
        padding: 26px 0 0 30px;
        p {
          font-size: 26px;
        }
        ul {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          margin-top: 24px;
          li {
            padding: 16px 24px;
            margin: 0 20px 20px 0;
            background: #f6f6f6;
            color: #98a3b3;
            font-size: 24px;
            border-radius: 4px;
          }
          .activeType,
          .activeFile {
            background: rgba(39, 127, 255, 0.13);
            color: #277fff;
          }
        }
      }
      .van-collapse {
        .van-collapse-item__content {
          padding: 0 30px;
          ul {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 24px;
            li {
              padding: 16px 24px;
              margin: 0 20px 20px 0;
              background: #f6f6f6;
              color: #98a3b3;
              font-size: 26px;
              border-radius: 4px;
            }
            .labelIndex {
              background: rgba(39, 127, 255, 0.13);
              color: #277fff;
            }
          }
        }
      }
      .date {
        margin: 26px 0 0 30px;
        p {
          font-size: 28px;
          margin-bottom: 24px;
        }
        .start-date,
        .end-date {
          width: calc((100% - 60px) / 2);
          display: inline-block;
          .van-cell {
            padding: 10px 20px;
            border: 1px solid #d8d8d8;
            border-radius: 4px;
            width: 300px;
            font-size: 28px;
            color: #333;
            .calendar-o {
              font-size: 28px;
              line-height: inherit;
            }
            .van-icon-calendar-o:before {
              color: #666;
            }
          }
        }
        .line {
          display: inline-block;
          margin: 0 10px;
          width: 22px;
          height: 2px;
          background-color: #d8d8d8;
        }
      }
      .cancelSub {
        margin-top: 50px;
        .van-button {
          width: 50%;
          display: inline-block;
        }
        .reset {
          border: none;
          background-color: #fafafa;
          color: #277fff;
        }
      }
    }
  }
  /deep/.van-picker__title {
    font-size: 24px;
    height: 30px;
    line-height: 30px;
  }
  /deep/.van-popup--bottom {
    height: 40% !important;
    border-radius: 16px 16px 0 0;
  }
  .tree-content {
    /deep/ .van-collapse {
      .reply-open,
      .reply-down {
        position: absolute;
        top: 50%;
        left: 30px;
        font-size: 14px;
        z-index: 1;
        margin-top: -7px;
      }
      .van-cell {
        padding: 10px 16px;
      }
      .van-cell__title {
        margin: 28px 0;
        margin-left: 40px;
        width: 100%;
        font-size: 28px;
        color: #333;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .material-file-list {
        .material-file-item {
          margin-bottom: 24px;
          background: #f1f6ff;
          border-radius: 12px;
          padding: 20px 24px;
          .content {
            display: flex;
            justify-self: flex-start;
            .img {
              margin-right: 16px;
              width: 134px;
              height: 134px;
              border-radius: 8px;

              img {
                width: 134px;
                height: 134px;
                border-radius: 8px;
              }
            }
            .videoImg {
              max-width: 150px;
              height: 134px;
              .video-img {
                width: 100%;
                height: 100%;
              }
            }
            .content-name {
              width: 100%;

              display: flex;
              flex-direction: column;
              justify-content: space-between;
              p {
                font-size: 26px;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
              .content-timeBtn {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .createTime {
                  font-size: 22px;
                  font-weight: 400;
                  color: #999;
                  display: inline-block;
                }
                .preview {
                  font-size: 22px;
                  font-weight: 400;
                  color: #277fff;
                  cursor: pointer;
                  display: inline-block;
                }
              }
            }
            .videoContent {
              flex: 1;
            }
          }
          .content-text {
            .pack-up,
            .unfold {
              color: #333;
              font-size: 26px;
              font-weight: 500;
              word-break: break-all;
            }
            .pack-up {
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 5;
            }
            .pack {
              color: #277fff;
              cursor: pointer;
              float: right;
            }
          }
          .createTime1 {
            margin-top: 16px;
            font-size: 22px;
            font-weight: 400;
            color: #999;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .noLimit,
  .noData {
    text-align: center;
    img {
      padding-top: 150px;
      width: 100%;
      height: 100%;
      max-width: 400px;
    }
    p {
      color: #999;
      font-size: 28px;
    }
  }
  .noLimit img {
    padding-top: 100px;
  }
  .popup-pdf {
    height: 80% !important;
    .detail-popup {
      padding: 100px 40px 20px;
      width: 100%;
      height: 100%;
      #pdf-detail {
        width: 100%;
        height: 100%;
      }
    }
  }
  /deep/.van-dialog {
    background: none;
    max-height: 70%;
    .van-dialog__content {
      margin-bottom: 30px;
      height: 500px;
      overflow-y: scroll;
      padding-bottom: 70px;
      background: #fff;
      img {
        width: 100%;
        max-height: 432px;
        // object-fit: cover;
        object-fit: contain;
      }
      video {
        width: 100%;
        height: 580px;
      }
      .btn {
        margin-top: 30px;
        text-align: center;
        height: 58px;
        border-top: solid 1px #ececec;
        position: fixed;
        bottom: 0;
        width: 100%;
        background: #fff;
        span {
          background: #fff;
          display: inline-block;
          border-radius: 34px;
          width: 30%;
          min-width: 100px;
          height: 48px;
          line-height: 58px;
          text-align: center;
          color: #666;
          font-size: 16px;
          font-weight: 400;
          .van-icon {
            border: 1px solid #277fff;
            border-radius: 50%;
            font-size: 16px;
          }
          &:first-child {
            color: #277fff;
            margin-right: 70px;
          }
        }
      }
    }
  }
}
</style>
